import styled from 'styled-components';
import Search from '../../../../Search';
import {Select} from "antd";

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledTableFiltersSearch = styled(Search)`
  max-width: 264px;
  width: 100%;
`;

const StyledTableFiltersSelect = styled(Select)`
  min-width: 190px;

  &.ant-select-lg {
    .ant-select-selector {
      &::after {
        line-height: 30px;
      }
    }
  }
`;

const StyledTableFiltersElements = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledRightSideContent = styled.div`
`;

export {
  StyledTableFiltersSearch,
  StyledTableFiltersSelect,
  StyledTableFilters,
  StyledTableFiltersElements,
  StyledRightSideContent
};
